export default class BackgroundStore {

    /**
     * @param morning {String}
     * @param day {String}
     * @param afternoon {String}
     * @param night {String}
     */
    constructor(morning, day, afternoon, night) {

        this.list = [
            "url(" + morning + ")",
            "url(" + day + ")",
            "url(" + afternoon + ")",
            "url(" + night + ")",
        ];

        /**
         * @type {{String:String}}
         */
        this.prev = {}

        this.pattern = /\s(\d+):\d+:\d+/;
    }


    /**
     * 時刻によって背景画像を変更
     * 時刻パースできなかった場合は、前回と同じ結果を返す
     *
     * 05:00- 早朝 3h
     * 08:00- ひる 9h
     * 17:00- 夕方 3h
     * 20:00- よる 9h
     *
     * @param z {String}
     * @param t {String}
     */
    getBackground(z, t) {

        let m = this.pattern.exec(t);
        if (m === null) {
            return this.prev[z] || null;
        }

        let h = parseInt(m[0]);

        if (5 <= h && h < 9) {
            return this.prev[z] = this.list[0];
        }
        if (9 <= h && h < 17) {
            return this.prev[z] = this.list[1];
        }
        if (17 <= h && h < 20) {
            return this.prev[z] = this.list[2];
        }
        if ((20 <= h && h < 24) || (0 <= h && h < 5)) {
            return this.prev[z] = this.list[3];
        }

        return this.prev[z] || null;
    }
}

